module.exports = __webpack_public_path__ + "vrplayerstatic/media/Revlity Logo.fbc25506.svg";